// extracted by mini-css-extract-plugin
export default {"lazyLoadSignal":"lazyLoadSignal__vPWC1"};